// extracted by mini-css-extract-plugin
export var column = "footer-module--column--256cH";
export var h1 = "footer-module--h1--3mF6P";
export var text = "footer-module--text--3qSo3";
export var a = "footer-module--a--1hkHt";